<h2 class="header">Books</h2>
<sci-book-overview class="book" *ngFor="let book of books" [book]="book"></sci-book-overview>
